var _circle, _rect, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIconBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 16.6667,
    transform: "matrix(1 0 0 -1 19.9999 19.9998)",
    stroke: "#F2BD35",
    strokeWidth: 2.22222
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.18519,
    height: 12.963,
    rx: 2.59259,
    transform: "matrix(1 0 0 -1 17.4075 22.3145)",
    fill: "#F2BD35"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 2.77778,
    transform: "matrix(1 0 0 -1 19.9999 27.8702)",
    fill: "#F2BD35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIconBig);
export default __webpack_public_path__ + "static/media/error-icon-big.330d455923d87e0bbf738abb1baa1472.svg";
export { ForwardRef as ReactComponent };